
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.884 1.116a1.25 1.25 0 00-1.768 0L1.161 9.071A1.25 1.25 0 102.93 10.84L10 3.768l7.071 7.07a1.25 1.25 0 101.768-1.767l-7.955-7.955zM11.25 3V2h-2.5v1h2.5z"}})])
          )
        }
      }
    